var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEducationHistories = function SvgEducationHistories(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 12,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M14.106 2.413 7.334.024a.42.42 0 0 0-.28 0L.28 2.414a.422.422 0 0 0 0 .794l6.771 2.408a.42.42 0 0 0 .283 0l6.772-2.408a.422.422 0 0 0-.001-.795M13.375 8.04V4.363l-.844.3V8.04a.846.846 0 0 0 0 1.468v2.071a.421.421 0 1 0 .843 0V9.508a.846.846 0 0 0 0-1.468"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M7.194 6.481q-.219 0-.424-.073L2.963 5.055V6.91c0 .453.473.837 1.407 1.14.814.264 1.817.41 2.824.41s2.01-.146 2.823-.41c.934-.303 1.407-.687 1.407-1.14V5.055L7.617 6.408a1.3 1.3 0 0 1-.423.073"
  })));
};
export default SvgEducationHistories;